import {Component, OnInit} from '@angular/core';
import {
    ObjectBaseModeComponent
} from "../../../../../../../core/shared/object/mvs-object-base/object-base-mode.component";
import {NavigationItem} from "../../../../../../../core/shared/dto/navigation/navigation-item";


@Component({
    selector: 'ei-structure-field-base',
    template: '',
    standalone: false
})
export class EiStructureFieldBaseComponent extends ObjectBaseModeComponent implements OnInit {


    navigationItems: NavigationItem[] = [
        {
            label: 'Basiskonfiguration',
            action: 'basicConfig',
            tooltip: 'Basiskonfiguration',
            icon: 'fa-solid fa-sliders',
            toggleable: false,
            default: true
        },
        {
            label: 'Feldwerte',
            action: 'fieldValues',
            tooltip: 'Feldwerte',
            icon: 'fa-solid fa-list-check',
            toggleable: false,
            default: false
        },
        {
            label: 'Import-Logik',
            action: 'importLogic',
            tooltip: 'Import-Logik',
            icon: 'fa-solid fa-code-branch',
            toggleable: false,
            default: false
        }
    ];


    ngOnInit() {
        super.ngOnInit();
    }


}
